module.exports = __webpack_public_path__ + "img/deliverables.35fb6ba3.svg";